<div class="main-container">
    <p-toast position="top-center" [style]="{width: '50%',marginTop: '40px'}" [baseZIndex]="12000"></p-toast>

    <div *ngIf="!showNavigation">
        <navigation
            [showingShelf]="shelf$ | async"
            [largeShelf]="largeShelf"
        />
    </div>

    <ng-container *ngIf="shelf$ | async as portal">
        <div class="shelf"
            [class.shelf-large]="largeShelf"
        >
            <ng-template [cdkPortalOutlet]="portal" />
        </div>
    </ng-container>

    <div id="scroll"
        [class.login-content]="showNavigation"
        [class.general-content]="!showNavigation"
        [style.overflow-y]="isExecutingTask ? 'hidden' : 'auto'"
        [style.position]="isExecutingTask ? 'relative' : 'initial'"
    >
        <div class="login"
            [style.margin]="!showNavigation? '-20px 0 0 -30px' : '0'"
            [style.padding-right]="!showNavigation? '26%' : '0'"
            *ngIf="isExecutingTask"
        >
            <preloader></preloader>
        </div>

        <router-outlet (activate)="onActivate($event)"></router-outlet>
    </div>
</div>

<ng-template #trialOver let-modal>
    <div class="modal-body">
        <trial-over 
          [businessName]="selectedBusiness.name" 
          [businessPhoneNumber]="( preferredLocation$ | async ).phoneNumber" 
          [businessZipCode]="( preferredLocation$ | async ).zipCode" 
          [userEmail]="loggedUser.email" 
          [userFullName]="userFullName()" 
          [trialOverForm]="'https://central-1.us.paradigmpost.com:3000/checkout/plan_GMR99M?'"
        />
    </div>
</ng-template>

<ng-template #phoneNumberUpdate let-modal>
    <phone-number-modal-form
        [showTitle]=false
        (onSave)="savePhoneNumber()">
        
        <button 
            class="btn btn btn-outline-secondary"
            (click)="updatePhoneNumberCancel()"
            >
            No Thanks 
        </button>
    </phone-number-modal-form>
</ng-template>